module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_varmdo-38b1670d00db93e2ee98833541f6a2c5.png";